// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-switch.is-disabled[data-v-e55abd20]{opacity:1}[data-v-e55abd20] .el-switch__label{cursor:pointer !important}", ""]);
// Exports
module.exports = exports;
